import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { Grid, Typography, Chip, FormControl, FormHelperText } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { ClientContext } from '../../ClientContext';
import { ClientErrorContext } from '../../ClientErrorContext';
import { ContentModel } from '../../../../Models/ContentModel';
import ContentService from '../../../../Services/ContentService';
import { EditAction } from '../../../../shared/enum/EditAction';
import { HomeContext } from '../../../Home/HomeContext';

const useStyles = makeStyles((theme: Theme) => createStyles({  
    titleSection: {
        marginBottom: theme.spacing(1)
    }
}));

export function ClientContents() {
    const classes = useStyles();
    
    const homeContext = React.useContext(HomeContext);
    const clientContext = React.useContext(ClientContext);
    const clientErrorContext = React.useContext(ClientErrorContext);   
    
    const [contents, setContents] = React.useState<ContentModel[]>([]);

    React.useEffect(() => {        
        ContentService
            .getAll()
            .then((res: AxiosResponse) => {
                if (res.data) {
                    setContents(res.data);
                }
            })
            .catch((error: AxiosError) => { homeContext.showError('', error); });
    }, []);

    const handleSelectContent = (content: ContentModel) => {
        const listContentSelect = (clientContext.contents)
            ? [...clientContext.contents]
            : [];
        const index = listContentSelect.findIndex(k => k.id == content.id);
        if (index >= 0) {
            if (listContentSelect[index].editAction == EditAction.DELETE)
                listContentSelect[index].editAction = EditAction.NONE;
            else if (listContentSelect[index].editAction == EditAction.INSERT)
                listContentSelect.splice(index, 1);
            else
                listContentSelect[index].editAction = EditAction.DELETE;
        }
        else
            listContentSelect.push({...content, editAction: EditAction.INSERT});
        
        clientContext.setContents(listContentSelect);        
    };
    return (
        <>
            {contents && contents.length > 0 &&
                    <Grid item xs={12}>
                        <FormControl component="fieldset" >
                            <Grid item xs={12} className={classes.titleSection}>
                                <Typography variant="subtitle1">Teor</Typography>
                            </Grid>
                            <Grid container spacing={1}>
                                {contents.map(content => {
                                    if (clientContext.contents.find(x => x.id == content.id && x.editAction != EditAction.DELETE))
                                        return (
                                            <Grid item key={content.id}>
                                                <Chip
                                                    key={content.id}                                                                                                            
                                                    label={content.name}                                                                                                                      
                                                    onClick={() => { handleSelectContent(content); }}
                                                    color='primary' />
                                            </Grid>
                                        );
                                    else
                                        return (
                                            <Grid item key={content.id}>
                                                <Chip
                                                    key={content.id}
                                                    variant="outlined"
                                                    label={content.name}                                                                                                           
                                                    onClick={() => { handleSelectContent(content); }}
                                                    color='primary' />
                                            </Grid>
                                        );
                                })}
                                { (clientErrorContext.contentNotDefinedError && !(clientContext.contents && clientContext.contents.length > 0)) && 
                                    <Grid item xs={12}>
                                        <FormHelperText error>
                                            Você precisa selecionar pelo menos um teor para este cliente.
                                        </FormHelperText>
                                    </Grid>
                                }
                            </Grid>                                                        
                        </FormControl>
                    </Grid>
            }
        </>
    );
}